import React from 'react';
import { string, bool, shape } from 'prop-types';
import HeroBanner from '../heroBanner';
import ThemeXHeader from '../themeXHeader';
import './style.scss';

function ThemeXContainer({
  showHeader,
  userData,
  showHeroBanner,
  isLoaded,
  altText,
  decorativeBanner,
  heroBannerImage,
  heroLogo,
  heroTitle,
  showHeroBackLink,
  heroBackText,
  redirectLink,
  heroBannerChildren,
  isDefaultCoverImage,
  children,
  isImageResizingEnabled,
  showLoginButton,
  title,
  showShare,
  shareUrl,
  disableLogoRedirect,
  hideLoginModal,
  renderMainLandmark,
}) {
  const ContentContainer = renderMainLandmark ? 'main' : 'div';

  return (
    <div id="themex-wrapper">
      <div id="themex-container" className={showHeader ? 'with-header-container' : ''}>
        <If condition={showHeader}>
          <ThemeXHeader
            userData={userData}
            showLoginButton={showLoginButton}
            title={title}
            showShare={showShare}
            shareUrl={shareUrl}
            disableLogoRedirect={disableLogoRedirect}
            hideLoginModal={hideLoginModal}
          />
        </If>
        <ContentContainer>
          <If condition={showHeroBanner}>
            <HeroBanner
              altText={altText}
              decorativeBanner={decorativeBanner}
              isImageResizingEnabled={isImageResizingEnabled}
              isLoaded={isLoaded}
              logo={heroLogo}
              bannerImage={heroBannerImage}
              title={heroTitle}
              showBackLink={showHeroBackLink}
              backText={heroBackText}
              redirectLink={redirectLink}
              isDefaultCoverImage={isDefaultCoverImage}>
              {heroBannerChildren}
            </HeroBanner>
          </If>
          <div id="themex-body">{children}</div>
        </ContentContainer>
      </div>
    </div>
  );
}

ThemeXContainer.propTypes = {
  showHeroBanner: bool.isRequired,
  isLoaded: bool,
  altText: string,
  decorativeBanner: bool,
  heroBannerImage: string.isRequired,
  heroLogo: string,
  heroTitle: string.isRequired,
  heroBackText: string.isRequired,
  redirectLink: string,
  showHeroBackLink: bool.isRequired,
  showHeader: bool,
  userData: shape().isRequired,
  isDefaultCoverImage: bool,
  isImageResizingEnabled: bool,
  title: string,
  showShare: bool,
  shareUrl: string,
  hideLoginModal: bool,
  renderMainLandmark: bool,
};

ThemeXContainer.defaultProps = {
  isLoaded: false,
  redirectLink: null,
  showHeader: false,
  isDefaultCoverImage: false,
  heroLogo: null,
  isImageResizingEnabled: false,
  title: '',
  showShare: false,
  shareUrl: '',
  hideLoginModal: false,
  renderMainLandmark: true,
  altText: '',
  decorativeBanner: false,
};
export default ThemeXContainer;
